(function () {
  'use strict';
  function initialize() {
    document.querySelectorAll('[data-plan-photo]').forEach(function (photo) {
      if (photo.dataset.planReady) return;
      photo.dataset.planReady = 'true';
      var choices = ['karazeh', 'assal'], choice = 'karazeh';
      try {
        // Share the existing visit lifetime; navigation on other pages refreshes lastSeen.
        var visit = JSON.parse(sessionStorage.getItem('vikis-pets-v3') || 'null');
        if (!visit || !visit.pages || !visit.counts || Date.now() - visit.lastSeen > 1800000) {
          visit = { seed: String(Date.now()) + Math.random(), counts: {}, pages: {} };
        }
        if (choices.indexOf(visit.feedingPlan) === -1) {
          visit.feedingPlan = choices[Math.floor(Math.random() * choices.length)];
        }
        visit.lastSeen = Date.now();
        sessionStorage.setItem('vikis-pets-v3', JSON.stringify(visit));
        choice = visit.feedingPlan;
      } catch (_) { choice = 'karazeh'; }
      // Review links show either approved composition without replacing the visit's choice.
      var review = new URLSearchParams(location.search).get('vikis_plans_preview');
      if (choices.indexOf(review) !== -1) choice = review;
      if (choice === photo.dataset.planChoice) return;
      var name = choice === 'assal' ? 'Assal & Ghazal' : 'Karazeh & Rushdi';
      var source = photo.dataset[choice + 'Src'];
      var replacement = new Image();
      replacement.onload = function () {
        var img = photo.querySelector('img');
        img.src = source;
        img.alt = name;
        photo.querySelector('figcaption').textContent = name;
        photo.dataset.planChoice = choice;
      };
      // A failed image load leaves the complete, approved server-rendered fallback intact.
      replacement.src = source;
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
